import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "sacarNull"
})
export class SacarNullPipe implements PipeTransform {

    transform(array: any[]): any {
        return array.filter(elemento => elemento != null);
    }

}
